<template>
    <rkm-form
        ref="Form"
    >
        <rkm-row class="mb-4">
            <rkm-col>
                <rkm-alert show color="info"><strong>Paciente:</strong> {{ model.nomePaciente }}</rkm-alert>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    label="Justificativa"
                    v-model="model.motivoCancelamentoEvasao"
                    placeholder="Digite o motivo que levou a cancelar a evasão"
                    :validations="validations.motivoCancelamentoEvasao"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                motivoCancelamentoEvasao: {
                    required: true,
                    max: 500,
                    min: 3,
                },
            }
        },
    },
    created() {
        this.repositories = {
            cancelamentoEvasao: this.getConectaSusRepository('prontoAtendimento.cancelamentoEvasao')
        }
    },
    methods: {
        save() {
            this.$refs.Form.validate().then(response => {
                if (response === true) {

                    const cancelamentoEvasao = () => this.repositories.cancelamentoEvasao.cancel(
                        this.model.faaId,
                        this.camelObjectKeysToSnakeRecursive(this.model)
                    )
                        .then(() => {
                            this.$emit('saved', this.model.faaId)
                        })
                        .catch(this.handleError)
                        .finally(() => this.showSaveNotification())

                    const message = this.model.setor
                        ? `O paciente irá retornar à fila de ${this.model.setor} para ser atendido. Deseja continuar?`
                        : `Ao reabrir o atendimento do(a) paciente ${this.model.nomePaciente}, será
                            possível encontrá-lo(a) na funcionalidade Fechamento de FAA. Deseja continuar?`

                    this.showAttentionConfirmation(message, cancelamentoEvasao, this.handleError)
                }
            })
        },
    },
    mixins: [ error, repository, stringCase ],
    props: {
        model: { type: Object, required: true },
    }
}
</script>